module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dyMZ6"))).then(() => parcelRequire('d0iPb'));